import { useDisabledPersonalInternetPermNotification } from "./useDisabledPersonalInternetPermNotification";

export function usePermanentNotifications() {
  useDisabledPersonalInternetPermNotification();
}
